module.exports = __webpack_public_path__ + "static/media/menu-icon-white.82d279c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/menu-icon-white.svg
// module id = 2489
// module chunks = 0